export { FullWidthLayout } from './FullWidthLayout';
export type { FullWidthLayoutProps } from './FullWidthLayout';
